// extracted by mini-css-extract-plugin
module.exports = {"content":"ExpeditionTeam_content__323su","title":"ExpeditionTeam_title__wQ_76","expedition_headshot":"ExpeditionTeam_expedition_headshot__3hAkQ"};